import { render, staticRenderFns } from "./botonesConfigurables.vue?vue&type=template&id=6faa8ee4&scoped=true&"
import script from "./botonesConfigurables.vue?vue&type=script&lang=js&"
export * from "./botonesConfigurables.vue?vue&type=script&lang=js&"
import style0 from "./botonesConfigurables.vue?vue&type=style&index=0&id=6faa8ee4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6faa8ee4",
  null
  
)

export default component.exports